(function () {
  const overlay      = document.getElementById('offcanvas-search-overlay');
  const closeBtn     = document.getElementById('searchPanelClose');
  const input        = document.getElementById('searchPanelInput');
  const grid         = document.getElementById('searchGrid');
  const viewAll      = document.getElementById('searchViewAll');
  const viewAllTxt   = document.getElementById('searchViewAllText');
  const catBtn       = document.getElementById('searchCatBtn');
  const catDrop      = document.getElementById('searchCatDropdown');
  const catLabel     = document.getElementById('searchCatLabel');
  const catItems     = document.querySelectorAll('.search-category__item');
  const resultsLabel = document.querySelector('.search-panel__results-label');

  let activeHandle = '';
  let debounceTimer;

  // ── Open / Close ──────────────────────────────────────────
  document.querySelectorAll('[data-search-open]').forEach(btn => {
    btn.addEventListener('click', openSearch);
  });

  function openSearch() {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => input.focus(), 300);
    if (activeHandle) loadCollectionProducts(activeHandle);
  }

  function closeSearch() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  closeBtn.addEventListener('click', closeSearch);
  overlay.addEventListener('click', e => { if (e.target === overlay) closeSearch(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeSearch(); });

  // ── Category Dropdown ─────────────────────────────────────
  catBtn.addEventListener('click', e => {
    e.stopPropagation();
    const isOpen = catDrop.classList.toggle('is-open');
    catBtn.setAttribute('aria-expanded', isOpen);
  });

  document.addEventListener('click', () => {
    catDrop.classList.remove('is-open');
    catBtn.setAttribute('aria-expanded', 'false');
  });

  catItems.forEach(item => {
    item.addEventListener('click', () => {
      catItems.forEach(i => {
        i.classList.remove('active');
        i.setAttribute('aria-selected', 'false');
      });
      item.classList.add('active');
      item.setAttribute('aria-selected', 'true');
      activeHandle = item.dataset.handle || '';
      catLabel.textContent = item.dataset.value || 'All Categories';
      catDrop.classList.remove('is-open');
      catBtn.setAttribute('aria-expanded', 'false');

      const q = input.value.trim();
      if (q) {
        fetchSearchResults(q);
      } else if (activeHandle) {
        loadCollectionProducts(activeHandle);
      } else {
        grid.innerHTML = '';
        viewAll.style.display = 'none';
        resultsLabel.style.display = 'none';
      }
    });
  });

  // ── Search Input ──────────────────────────────────────────
  input.addEventListener('input', e => {
    clearTimeout(debounceTimer);
    const q = e.target.value.trim();

    if (!q) {
      if (activeHandle) {
        loadCollectionProducts(activeHandle);
      } else {
        grid.innerHTML = '';
        viewAll.style.display = 'none';
        resultsLabel.style.display = 'none';
      }
      return;
    }

    debounceTimer = setTimeout(() => fetchSearchResults(q), 350);
  });

  // ── Load Collection Products (no search query) ────────────
  async function loadCollectionProducts(handle) {
    showLoading();
    resultsLabel.textContent = 'BROWSING COLLECTION';
    resultsLabel.style.display = 'block';
    viewAll.style.display = 'none';

    try {
      const res  = await fetch(`/collections/${handle}/products.json?limit=8`);
      const data = await res.json();
      const products = data.products || [];

      if (!products.length) {
        grid.innerHTML = '<p class="search-panel__empty">Is collection mein koi product nahi hai.</p>';
        return;
      }

      grid.innerHTML = products.map(p => buildProductCard(p)).join('');

      viewAllTxt.textContent = catLabel.textContent;
      viewAll.href = `/collections/${handle}`;
      viewAll.style.display = 'flex';

    } catch (err) {
      grid.innerHTML = '<p class="search-panel__empty">Products load nahi hue. Dobara try karein.</p>';
      console.error('Collection load error:', err);
    }
  }

  // ── Predictive Search ─────────────────────────────────────
  async function fetchSearchResults(query) {
    showLoading();
    resultsLabel.textContent = 'SEARCH RESULTS';
    resultsLabel.style.display = 'block';

    const url = `/search/suggest.json?q=${encodeURIComponent(query)}`
      + `&resources[type]=product`
      + `&resources[limit]=8`
      + `&resources[options][fields]=title,product_type,variants.title`
      + `&resources[options][unavailable_products]=last`;

    try {
      const res  = await fetch(url);
      const data = await res.json();
      let products = data.resources?.results?.products || [];

      // Client-side collection filter
      if (activeHandle && products.length) {
        const colRes  = await fetch(`/collections/${activeHandle}/products.json?limit=250`);
        const colData = await colRes.json();
        const colHandles = new Set((colData.products || []).map(p => p.handle));
        products = products.filter(p => colHandles.has(p.handle));
      }

      renderSearchProducts(products, query);

    } catch (err) {
      grid.innerHTML = '<p class="search-panel__empty">Search mein problem aayi. Dobara try karein.</p>';
      console.error('Search error:', err);
    }
  }

  // ── Render Search Products ────────────────────────────────
  function renderSearchProducts(products, query) {
    viewAllTxt.textContent = query;
    let searchUrl = `/search?q=${encodeURIComponent(query)}&type=product`;
    if (activeHandle) searchUrl += `&filter.collection=${activeHandle}`;
    viewAll.href = searchUrl;

    if (!products.length) {
      grid.innerHTML = `<p class="search-panel__empty">"${query}" ke liye koi product nahi mila.</p>`;
      viewAll.style.display = 'flex';
      return;
    }

    grid.innerHTML = products.map(p => buildProductCard(p)).join('');
    viewAll.style.display = 'flex';
  }

  // ── Build Product Card ────────────────────────────────────
  // Dono APIs handle karta hai:
  //   Predictive Search  → p.price (integer cents), p.compare_at_price (integer cents)
  //   products.json      → p.variants[0].price (string "2199.00"), p.variants[0].compare_at_price
  function buildProductCard(p) {
    const title   = p.title  || '';
    const url     = p.url    || `/products/${p.handle}`;
    const variant = p.variants?.[0];

    // ── Price parsing ─────────────────────────────────────
    let currentPrice = null;
    let comparePrice = null;

    if (p.price !== undefined && p.price !== null) {
      // Predictive Search API — cents (integer)
      currentPrice = parseFloat(p.price) / 100;
      const rawCmp = parseFloat(p.compare_at_price);
      if (!isNaN(rawCmp) && rawCmp > parseFloat(p.price)) {
        comparePrice = rawCmp / 100;
      }
    } else if (variant) {
      // products.json API — string e.g. "2199.00"
      currentPrice = variant.price ? parseFloat(variant.price) : null;
      const rawCmp = parseFloat(variant.compare_at_price);
      if (!isNaN(rawCmp) && rawCmp > currentPrice) {
        comparePrice = rawCmp;
      }
    }

    const hasDiscount = comparePrice !== null && comparePrice > currentPrice;

    const fmt = (amount) =>
      amount !== null && !isNaN(amount)
        ? '&#8377; ' + amount.toLocaleString('en-IN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })
        : '';

    const discountPct = hasDiscount
      ? Math.round((1 - currentPrice / comparePrice) * 100)
      : 0;

    // ── Image ─────────────────────────────────────────────
    const imgSrc = p.featured_image?.url || p.images?.[0]?.src || '';
    const imgHtml = imgSrc
      ? `<img src="${imgSrc}${imgSrc.includes('?') ? '&' : '?'}width=300"
             alt="${title}" loading="lazy" width="150" height="120">`
      : '<span>No image</span>';

    // ── Discount badge ────────────────────────────────────
    const badgeHtml = discountPct > 0
      ? `<span class="search-product-card__badge">-${discountPct}%</span>`
      : '';

    // ── Price HTML ────────────────────────────────────────
    const priceHtml = hasDiscount
      ? `<p class="search-product-card__price">
           <span class="search-product-card__price--sale">${fmt(currentPrice)}</span>
           <span class="search-product-card__price--compare">${fmt(comparePrice)}</span>
         </p>`
      : `<p class="search-product-card__price">${fmt(currentPrice)}</p>`;

    return `
      <a href="${url}" class="search-product-card">
        <div class="search-product-card__img">
          ${imgHtml}
          ${badgeHtml}
        </div>
        <div class="search-product-card__info">
          <p class="search-product-card__name">${title}</p>
          ${priceHtml}
        </div>
      </a>`;
  }

  // ── Loading State ─────────────────────────────────────────
  function showLoading() {
    grid.innerHTML = `
      <div class="search-panel__loading">
        <span class="search-spinner"></span> Loading...
      </div>`;
    viewAll.style.display = 'none';
  }

})();